const initialState = {
    isLoading         : true,
    data              : null,
    shouldTakeFromApi : false, // To know if user hasn't introduced language at settings and has to be taken from api.
    error             : false,
};

const translations = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case 'TRANSLATIONS_REQUEST_START':
            return {
                ...state,
                isLoading: true,
            };
        case 'TRANSLATIONS_REQUEST_SUCCESS':
            return {
                isLoading : false,
                data      : action.payload,
                error     : false,
            };
        case 'TRANSLATIONS_REQUEST_FAILURE':
            return {
                ...state,
                isLoading : false,
                data      : { ...state.data, errorInformation: action.payload },
                error     : true,
            };
        case 'TOGGLE_SHOULD-TAKE_FROM_API':
            return {
                ...state,
                shouldTakeFromApi: !state.shouldTakeFromApi,
            };
        default:
            return state;
    }
};

export default translations;
